import React from 'react';

export default function bookForm(props) {
  const validateBookForm = () => {
    var test = true;
    if (props.bookPseudo.length >= 0 && props.bookPseudo.length <= 2) {
      document.querySelector('#reservationNameLabel').style = 'color: red';
      test = false;
    } else {
      document.querySelector('#reservationNameLabel').style = 'color: black';
    }
    if (props.duration.length === 0) {
      document.querySelector('#durationLabel').style = 'color: red';
      test = false;
    } else {
      document.querySelector('#durationLabel').style = 'color: black';
    }
    if (props.serviceType.length === 0) {
      document.querySelector('#serviceTypeLabel').style = 'color: red';
      test = false;
    } else {
      document.querySelector('#serviceTypeLabel').style = 'color: black';
    }
    if (document.querySelector('#reservationCGV').checked === false) {
      document.querySelector('#reservationCGVLabel').style = 'color: red';
      test = false;
    } else {
      document.querySelector('#reservationCGVLabel').style = 'color: black';
    }
    if (!test) {
      return ;
    }
    props.setOpenDay({
      disp: false,
      dayName: '',
      day: 0,
      month: '',
      year: '',
    });
    props.setBookForm({
      disp: false,
    })
      props.setDemoMessage({
      disp: true,
      title: 'You\'re on a demo version',
      message: 'Your data will not be saved.',
      name: props.bookPseudo,
      data: props.bookForm.day + ' - ' + props.bookForm.hour,
    });
  }
  return (
    <div className="open_day_container">
          <div className="open_day_content" id="showPlanningFormContent">
          <div
                className="hideCommentForm"
                onClick={() => {
                  document.querySelector('#showPlanningFormContent').style.animation =
                    'hide_demo_message_container 0.6s linear';
                    setTimeout(() => {
                  props.setBookForm({disp: false});
                  props.setDuration('');
                  props.setServiceType('');
                  props.setBookPseudo('');
                  }, 350);
                  }}>
                <img
                  className="add_comment"
                  src={process.env.PUBLIC_URL + '/icons/go_back_70x70.ico'}
                  width="50"
                  height="50"
                  alt="go back" />
            </div>
            <div className="open_day_title">
              You would like to make a reservation on 
              <br></br>
              <span style={{color: 'brown'}}>{'\t' + props.bookForm.day + '\t'}</span>
              at
              <span style={{color: 'brown'}}>
                {'\t' + props.bookForm.hour}
                {props.bookForm.hour.substring(props.bookForm.hour.length - 1) === 'h' ? '00' : ''}
              </span>
            </div>
            <div className="reservationDivText">
              <label id="reservationNameLabel">What's your name?</label>
              <input
                type="text" size="20" minLength="2" maxLength="20"
                className="reservationText"
                id="reservationName"
                onChange={e => props.setBookPseudo(e.target.value)}
                value={props.bookPseudo}
                required />
            </div>
            <div className="reservationDiv">
              <label id="durationLabel">How long would you like to reserve for?</label>
              <div className="choiceDiv">
                <div className="choiceDiv2">
                  <div className="oneChoiceDiv">
                    <input
                        type="radio"
                        name="reservationDuration"
                        onChange={() => props.setDuration('0.5')}
                        value="type1" />
                    <label
                      style={{
                        color: props.duration === "0.5" ? 'blue' : 'black',
                        fontWeight: props.duration === "0.5" ? '800' : '',
                        textDecoration: props.duration === "0.5" ? 'underline' : '',
                        }}>30 min</label>
                  </div>
                  <div className="oneChoiceDiv">
                    <input
                        type="radio"
                        name="reservationDuration"
                        onChange={() => props.setDuration('1')}
                        value="type2" />
                    <label
                      style={{
                        color: props.duration === "1" ? 'blue' : 'black',
                        fontWeight: props.duration === "1" ? '800' : '',
                        textDecoration: props.duration === "1" ? 'underline' : '',
                        }}>1 hour</label>
                  </div>
                </div>
                <div className="choiceDiv2">
                  <div className="oneChoiceDiv">
                    <input
                        type="radio"
                        name="reservationDuration"
                        onChange={() => props.setDuration('1.5')}
                        value="type3" />
                    <label
                      style={{
                        color: props.duration === "1.5" ? 'blue' : 'black',
                        fontWeight: props.duration === "1.5" ? '800' : '',
                        textDecoration: props.duration === "1.5" ? 'underline' : '',
                        }}>1.5 hour</label>
                  </div>
                  <div className="oneChoiceDiv">
                    <input
                        type="radio"
                        name="reservationDuration"
                        onChange={() => props.setDuration('2')}
                        value="type4" />
                    <label
                      style={{
                        color: props.duration === "2" ? 'blue' : 'black',
                        fontWeight: props.duration === "2" ? '800' : '',
                        textDecoration: props.duration === "2" ? 'underline' : '',
                        }}>2 hours</label>
                  </div>
                </div>
              </div>
            </div>
            <div className="reservationDiv">
              <label id="serviceTypeLabel">What type of service do you want?</label>
              <div className="choiceDiv">
                <div className="choiceDiv2">
                  <div className="oneChoiceDiv">
                    <input
                        type="radio"
                        name="reservationType"
                        onChange={() => props.setServiceType('type1')}
                        value="type1" />
                    <label
                      style={{
                        color: props.serviceType === "type1" ? 'blue' : 'black',
                        fontWeight: props.serviceType === "type1" ? '800' : '',
                        textDecoration: props.serviceType === "type1" ? 'underline' : '',
                        }}>Type 1</label>
                  </div>
                  <div className="oneChoiceDiv">
                    <input
                        type="radio"
                        name="reservationType"
                        onChange={() => props.setServiceType('type2')}
                        value="type2" />
                    <label
                    style={{
                      color: props.serviceType === "type2" ? 'blue' : 'black',
                      fontWeight: props.serviceType === "type2" ? '800' : '',
                        textDecoration: props.serviceType === "type2" ? 'underline' : '',
                      }}>Type 2</label>
                  </div>
                </div>
                <div className="choiceDiv2">
                  <div className="oneChoiceDiv">
                    <input
                        type="radio"
                        name="reservationType"
                        onChange={() => props.setServiceType('type3')}
                        value="type3" />
                    <label
                      style={{
                        color: props.serviceType === "type3" ? 'blue' : 'black',
                        fontWeight: props.serviceType === "type3" ? '800' : '',
                        textDecoration: props.serviceType === "type3" ? 'underline' : '',
                        }}>Type 3</label>
                  </div>
                  <div className="oneChoiceDiv">
                    <input
                        type="radio"
                        name="reservationType"
                        onChange={() => props.setServiceType('type4')}
                        value="type4" />
                    <label
                      style={{
                        color: props.serviceType === "type4" ? 'blue' : 'black',
                        fontWeight: props.serviceType === "type4" ? '800' : '',
                        textDecoration: props.serviceType === "type4" ? 'underline' : '',
                        }}>Type 4</label>
                  </div>
                </div>
              </div>
            </div>
            <div className="reservationDiv">
              <label id="reservationCGVLabel">You are fully informed of our conditions of sale</label>
              <input type="checkbox" name="reservationCGV" id="reservationCGV"/>
            </div>
            <div style={{width: '100%', maxWidth: '650px',display: 'flex', justifyContent: 'space-around'}}>
              <button
                className="reservation_buts"
                style={{'--reservation_buts_bg': 'transparent'}}
                onClick={() => {
                  document.querySelector('#showPlanningFormContent').style.animation =
                    'hide_demo_message_container 0.6s linear';
                    setTimeout(() => {
                  props.setBookForm({disp: false});
                  props.setDuration('');
                  props.setServiceType('');
                  props.setBookPseudo('');
                  }, 350);
                  }}>
                  <img
                      className="add_comment"
                      src={process.env.PUBLIC_URL + '/icons/go_back_70x70.ico'}
                      width="50"
                      height="50"
                      alt="go back" />
              </button>
              <button
                className="reservation_buts"
                style={{'--reservation_buts_bg': '#5BD845'}}
                onClick={() => validateBookForm()}>
                    VALIDATE
              </button>
            </div>
          </div>
        </div>
  )
}
